export default __webpack_public_path__ + "static/media/icon-fb.00124889.svg";